import { ORGANIZER_DIRECTIONS_MAX_LENGTH } from "./OrganizerDirections.constants";
import {
  directionsLabel,
  directionsTextareaCss,
  directionsTextareaCssWrapper,
} from "./OrganizerDirections.styles";

interface OrganizerDirectionsProps {
  name: string;
  value: string;
  handleChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const OrganizerDirections = ({
  name,
  value,
  handleChange,
}: OrganizerDirectionsProps) => {
  const formattedName = name.toLowerCase().replace(/\s+/g, "-");
  const qaSelector = `exportables-${formattedName}-directions-input`;
  return (
    <div css={directionsTextareaCssWrapper}>
      <label htmlFor="organizer-directions" css={directionsLabel}>
        Directions
      </label>
      <textarea
        id="organizer-directions"
        data-qa-selector={qaSelector}
        value={value}
        onChange={handleChange}
        aria-label={`${name} organizer directions`}
        css={directionsTextareaCss(
          value.length > ORGANIZER_DIRECTIONS_MAX_LENGTH / 2,
        )}
        maxLength={ORGANIZER_DIRECTIONS_MAX_LENGTH}
      />
    </div>
  );
};

export default OrganizerDirections;
